import { useSyncExternalStore } from 'react';

const COARSE_POINTER_QUERY = '(pointer: coarse)';

function readTouchPrimary(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
    return false;
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  return hasTouch && window.matchMedia(COARSE_POINTER_QUERY).matches;
}

function subscribe(onChange: () => void): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
    return () => {};
  const controller = new AbortController();
  const { signal } = controller;
  window
    .matchMedia(COARSE_POINTER_QUERY)
    .addEventListener('change', onChange, { signal });
  // Hybrid devices can switch primary input without a media-query change.
  window.addEventListener('pointerdown', onChange, { signal, passive: true });
  return () => controller.abort();
}

const getServerSnapshot = () => false;

/**
 * Whether touch is the primary input. Read synchronously on the client's first
 * render (outside hydration), so components that branch on it — ScrollArea's
 * native vs Radix viewport — mount the right tree once instead of swapping
 * elements after an effect.
 */
export function useTouchPrimary(): boolean {
  return useSyncExternalStore(subscribe, readTouchPrimary, getServerSnapshot);
}
